
import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useRsvp } from '../../hooks/useRsvp';
import AuthModal from '../AuthModal';

interface RsvpButtonProps {
  eventId: string;
  className?: string;
  variant?: 'primary' | 'secondary';
}

export default function RsvpButton({
  eventId,
  className = '',
  variant = 'primary',
}: RsvpButtonProps) {
  const { isAuthenticated } = useAuth();
  const { hasRsvp, toggleRsvp } = useRsvp();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!isAuthenticated) {
      setShowAuthModal(true);
      return;
    }

    setLoading(true);
    await toggleRsvp(eventId);
    setLoading(false);
  };

  const rsvped = hasRsvp(eventId);

  const baseClasses = 'px-6 py-3 rounded-lg font-medium transition-colors disabled:opacity-50 whitespace-nowrap flex items-center gap-2';
  
  const variantClasses = variant === 'primary'
    ? rsvped
      ? 'bg-teal-100 text-teal-700 hover:bg-teal-200'
      : 'bg-teal-600 text-white hover:bg-teal-700'
    : rsvped
    ? 'border-2 border-teal-600 text-teal-600 hover:bg-teal-50'
    : 'border-2 border-gray-300 text-gray-700 hover:border-teal-600 hover:text-teal-600';

  return (
    <>
      <button
        onClick={handleClick}
        disabled={loading}
        className={`${baseClasses} ${variantClasses} ${className}`}
      >
        <i className={`${rsvped ? 'ri-check-line' : 'ri-calendar-check-line'} text-lg`}></i>
        {rsvped ? 'RSVP Confirmed' : 'RSVP Now'}
      </button>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onSuccess={() => setShowAuthModal(false)}
      />
    </>
  );
}
